import Phaser from 'phaser';
import { tokens } from '../design/tokens';
import { audio } from '../game/Audio';

const KEY_MUTED = 'lavascend.muted';
const ICON_MUTED = '\u{1F507}'; // 🔇
const ICON_UNMUTED = '\u{1F50A}'; // 🔊

export function createMuteButton(
  scene: Phaser.Scene,
  x: number,
  y: number,
): Phaser.GameObjects.Text {
  const isMuted = (): boolean => localStorage.getItem(KEY_MUTED) === '1';

  const btn = scene.add.text(x, y, isMuted() ? ICON_MUTED : ICON_UNMUTED, {
    fontFamily: tokens.type.hud.family,
    fontSize: '18px',
    color: tokens.colors.ui.accent,
  })
    .setOrigin(0.5, 0)
    .setInteractive({ useHandCursor: true });

  btn.on('pointerdown', (
    _pointer: Phaser.Input.Pointer,
    _lx: number,
    _ly: number,
    event: Phaser.Types.Input.EventData,
  ) => {
    event.stopPropagation();
    // Tap is a user gesture — safe to lazily init audio so the uiTap SFX and the
    // mute toggle take effect even if the player toggles mute on Title before
    // ever pressing play.
    audio.init();
    const next = !isMuted();
    localStorage.setItem(KEY_MUTED, next ? '1' : '0');
    btn.setText(next ? ICON_MUTED : ICON_UNMUTED);
    audio.uiTap();
    audio.setMuted(next);
    // Unmuting on Title is the player's signal that they want sound — start the
    // music if it hasn't started yet. audio.music() is idempotent, so this is a
    // no-op once music is running.
    if (!next) audio.music();
    // Kept for any other UI that wants to react to mute changes.
    scene.game.events.emit('lavascend:mute', next);
  });

  return btn;
}
